import produce from 'immer';

import * as constants from './constants';
import { HintStore, HintAction } from './typings';

const initialState: HintStore = {
    config: null,
    matchedHints: [],
};

const wizard = (state: HintStore = initialState, action: HintAction) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.SET_CONFIG:
                draft.config = action.config;
                break;

            case constants.SET_MATCHED_HINTS:
                draft.matchedHints = action.hints;
                break;

            default:
                break;
        }
    });
};

export default wizard;
